<template>
  <div id="userHome">
    <table-coms
            v-if="data.tableList != undefined"
            :tableData="data.tableList.data"
            :cols="data.tableList.columns"
            :key="substr"
            :fixedNum="fixedNum"
            v-on:rederSub="GetrederSub"
            :checkboxFlag="true"
            v-on:selectRowData="getSelectDataTop"
            v-on:checkBoxSelectData="getBoxSelectData"
            :loading="parloading"
            ref="tablsUser"
            :setGmcuid="tableGmcuid"
            :subParAnsear="true"
            v-on:renderSearchVal="getredSearchVal"
            v-on:renderSortVal="getrenderSortVal"
            v-on:renderQueryVal="getrenderQueryVal"
            :TitleSearchVal="TitleSearchVal"
            :MaxHeight="MaxHeight"
    >
      <template slot="topFunction">
        <div style="display: flex;justify-content: space-between;width: calc(100% - 10px);height: 35px;align-items: center;">
          <div>
            <a-row type="flex" justify="start">
              <a-col style="margin: 0 4px" v-if="Role == 'SYSTEM_ADMIN'">
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>Create</span>
                  </template>
                  <img @click="createUser" class="sbxs" src="../../assets/img/ss-add.png" width="20" height="20">
                </a-tooltip>
              </a-col>
              <a-col style="margin: 0 4px">
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span> {{$t('userlang.Enable')}}</span>
                  </template>
                  <a-button
                          size="small"
                          type="primary"
                          shape="circle"
                          icon="safety"
                          @click="logoutEffect('Effect')"
                  >
                  </a-button>
                </a-tooltip>
              </a-col>
              <a-col>
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>{{ $t('userlang.Disable') }}</span>
                  </template>
                  <a-button
                          size="small"
                          type="primary"
                          shape="circle"
                          icon="poweroff"
                          style="background: #a0e45d;border:1px solid #a0e45d"
                          @click="logoutEffect('logout')"
                  >
                  </a-button>
                </a-tooltip>
              </a-col>
              <a-col v-if="false">
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>{{ $t('userlang.Empower') }}</span>
                  </template>
                  <a-button
                          size="small"
                          type="primary"
                          shape="circle"
                          icon="usergroup-add"
                          style="background: #1890ff;border:1px solid #1890ff;margin: 0 10px"
                          @click="empowerEvent"
                  >
                  </a-button>
                </a-tooltip>
              </a-col>
              <a-col style="margin-left: 4px;">
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>Batch Update</span>
                  </template>
                  <a-button
                      size="small"
                      type="primary"
                      shape="circle"
                      icon="swap"
                      @click="batchUpdata"
                  >
                  </a-button>
                </a-tooltip>
              </a-col>
              <a-col class="ml4" style="margin-top: 2px;">
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>Refresh</span>
                  </template>
                  <img class="sbxs" @click="handleToolClick" src="../../assets/img/ss-refresh.png" width="17" height="18">
                </a-tooltip>
              </a-col>


              <a-col class="ml4" style="margin-top: 2px;">
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>Import</span>
                  </template>
                  <img class="sbxs" @click="popUpImport" src="../../assets/img/ss-import.png" width="17" height="18">
                </a-tooltip>
              </a-col>


<!-- 
               <span style="float: left;margin-left: 6px;">
                      <a-icon type="search" style="margin-right: 4px;"/>
                         <a-select style="width: 180px" size="small" @change="skuTableTemplateData" v-model="parTableTemplateName" placeholder="Please select template">      
                                     <a-select-option value="all">all</a-select-option>
                                      <a-select-option
                                              :key="item"
                                              :value="item"
                                              v-for="item in parTableTemplateSelect"
                                      >{{ item }}</a-select-option>
                       </a-select>
                </span> -->

            </a-row>
          </div>
          <div>
            <a-pagination
                    :pageSizeOptions="pageSizeOptions"
                    :showTotal="total => `${$t('generic.totalOf')} ${pagingTotal} ${$t('generic.Records')}`"
                    size="small"
                    :total="pagingTotal"
                    v-model="currentVal"
                    :pageSize.sync="pagingSize"
                    @change="tableChangePage"
                    @showSizeChange="onShowSizeChange"
                    showSizeChanger

            />
          </div>
        </div>
      </template>
    </table-coms>

    <!--添加-->
    <a-modal title="Add" v-model="CreateUserVis" width="70%">
      <template slot="footer">
        <a-button type="primary" size="small" @click="saveCreateUser">{{ $t('userlang.Save') }}</a-button>
      </template>
      <a-form :form="createUserform" >
        <a-collapse v-model="activeKey" :bordered="false">
          <a-collapse-panel key="1" header="Main">
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item :label="$t('userlang.UserAccount')" v-bind="userEditLayout">
                  <a-input
                    size="small"
                    :placeholder="$t('userlang.UserAccount')"
                    v-decorator="[
                    'userAccount',
                    {
                       rules: [
                          {
                            required: true,
                            message: $t('publicLang.Required')
                          },
                        ],
                     }
                  ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.Email')" v-bind="userEditLayout">
                  <a-input
                          size="small"
                          :placeholder="$t('userlang.Email')"
                          v-decorator="[
                        'email',
                        {
                           rules: [
                              {
                                type: 'email',
                                message: $t('publicLang.PleaseinputEmail')
                              },
                              {
                                required: true,
                                message: $t('publicLang.PleaseinputEmail')
                              },
                            ],
                        }
                    ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item v-bind="userEditLayout" :label="$t('userlang.FirstName')">
                  <a-input
                          size="small"
                          autocomplete="off"
                          :placeholder="$t('userlang.FirstName')"
                          style="width: 100%"
                          v-decorator="[
                      'firstName',
                      {
                        rules: [{ required: true, message: $t('publicLang.Required') }]
                      }
                    ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item v-bind="userEditLayout" :label="$t('userlang.MiddleName')">
                  <a-input
                      :placeholder="$t('userlang.MiddleName')"
                      autocomplete="off"
                      size="small"
                      style="width: 100%"
                      v-decorator="[
                      'middleName'
                    ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item v-bind="userEditLayout" :label="$t('userlang.LastName')">
                  <a-input
                          :placeholder="$t('userlang.LastName')"
                          autocomplete="off"
                          style="width: 100%"
                          size="small"
                          v-decorator="[
                        'lastName',
                        {
                          rules: [{ required: true, message: $t('publicLang.Required') }]
                        }
                      ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item v-bind="userEditLayout" :label="$t('userlang.DisplayName')">
                  <a-input
                          :placeholder="$t('userlang.DisplayName')"
                          autocomplete="off"
                          style="width: 100%"
                          size="small"
                          v-decorator="[
                      'dispName',
                      {
                        rules: [{ required: true, message: $t('publicLang.Required') }]
                      }
                      ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('login.Username')" v-bind="userEditLayout">
                  <a-input
                      autocomplete="off"
                      size="small"
                      style="width: 100%"
                      :placeholder="$t('publicLang.PleaseEnter')"
                      v-decorator="[
                      'username'
                    ]"/>
                </a-form-item>
              </a-col>

              <a-col :span="8">
                <a-form-item :label="$t('userlang.domain')" v-bind="userEditLayout">
                  <a-input
                    autocomplete="off"
                    size="small"
                    style="width: 100%"
                    :placeholder="$t('userlang.domain')"
                    v-decorator="[
                      'domain'
                    ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.useredQr')" v-bind="userEditLayout">
                  <a-select v-decorator="['useredQr']" style="width: 100%" size="small" allowClear>
                    <a-select-option value="Y">Y</a-select-option>
                    <a-select-option value="N">N</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-collapse-panel>
          <a-collapse-panel key="2" header="Contact">
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item :label="$t('userlang.Company')" v-bind="userEditLayout">
                  <a-input
                      :placeholder="$t('userlang.Company')"
                      autocomplete="off"
                      style="width: 100%"
                      size="small"
                      v-decorator="[
                      'companyName'
                    ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.Department')" v-bind="userEditLayout">
                  <a-input
                    autocomplete="off"
                    style="width: 100%"
                    size="small"
                    :placeholder="$t('userlang.Department')"
                    v-decorator="[
                    'departName'
                ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.Position')" v-bind="userEditLayout">
                  <a-input
                      autocomplete="off"
                      style="width: 100%"
                      size="small"
                      :placeholder="$t('userlang.Position')"
                      v-decorator="[
                        'position'
                      ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.Telephone')" v-bind="userEditLayout">
                  <a-input
                      autocomplete="off"
                      style="width: 100%"
                      size="small"
                      :placeholder="$t('userlang.Telephone')"
                      v-decorator="[
                      'telNum'
                    ]"/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-collapse-panel>
          <a-collapse-panel key="3" header="Address">
            <a-row :gutter="24">
              <a-col :span="8" v-if="false">
                <a-form-item :label="$t('userlang.Orgnization')" v-bind="userEditLayout" v-if="userEditData.systemAdminMark">
                  <a-select
                        style="width: 100%"
                        size="small"
                        :placeholder="$t('publicLang.PleaseSelect')"
                        v-decorator="[
                            'orgCode',
                            {rules: [{ required: true, message: $t('publicLang.Required') }]}
                      ]">
                    <a-select-option v-for="item in userEditData.OrganizationList" :value="item.orgCode">{{item.displayName}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.Address1')" v-bind="userEditLayout">
                  <a-input
                    size="small"
                    :placeholder="$t('userlang.Address1')"
                    v-decorator="[
                    'address1'
                  ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.Address2')" v-bind="userEditLayout">
                  <a-input
                    size="small"
                    :placeholder="$t('userlang.Address2')"
                    v-decorator="[
                    'address2'
                  ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.Address3')" v-bind="userEditLayout">
                  <a-input
                    size="small"
                    :placeholder="$t('userlang.Address3')"
                    v-decorator="[
                    'address3'
                  ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.Address4')" v-bind="userEditLayout">
                  <a-input
                    size="small"
                    :placeholder="$t('userlang.Address4')"
                    v-decorator="[
                    'address4'
                  ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.Postal')" v-bind="userEditLayout">
                  <a-input
                    size="small"
                    :placeholder="$t('userlang.Postal')"
                    v-decorator="[
                    'postal'
                  ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.Street')" v-bind="userEditLayout">
                  <a-input
                    size="small"
                    :placeholder="$t('userlang.Street')"
                    v-decorator="[
                    'street'
                  ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.District')" v-bind="userEditLayout">
                  <a-input
                    size="small"
                    :placeholder="$t('userlang.District')"
                    v-decorator="[
                    'district'
                  ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.Latitude')" v-bind="userEditLayout">
                  <a-input
                    size="small"
                    :placeholder="$t('userlang.Latitude')"
                    v-decorator="[
                    'latitude'
                  ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.Longitude')" v-bind="userEditLayout">
                  <a-input
                    size="small"
                    :placeholder="$t('userlang.Longitude')"
                    v-decorator="[
                    'longitude'
                  ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.Country')" v-bind="userEditLayout">
                  <a-input
                    size="small"
                    :placeholder="$t('userlang.Country')"
                    v-decorator="[
                    'country'
                  ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.City')" v-bind="userEditLayout">
                  <a-cascader
                        :options="cityOptions"
                        size="small"
                        @change="cityChange"
                        :loadData="cityLoadData"
                        :placeholder="$t('publicLang.PleaseSelect')"
                        changeOnSelect
                        :fieldNames="{ value: 'ebplCode', label: 'ebplNameEn', children: 'children' }"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </a-collapse-panel>
          <a-collapse-panel key="4" header="Parameter">
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item :label="$t('userlang.Language')" v-bind="userEditLayout">
                  <a-select
                      style="width: 100%"
                      size="small"
                      allowClear
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="[
                      'defaultLang',
                      {
                        rules: [{ required: true, message: $t('publicLang.Required') }]
                      }
                    ]">
                    <a-select-option value="0">{{ $t('userlang.Jtlang') }}</a-select-option>
                    <a-select-option value="1">{{ $t('userlang.ftlang')}}</a-select-option>
                    <a-select-option value="2">English</a-select-option>
                    <a-select-option value="3">{{ $t('userlang.korlang')}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.TimeZone')" v-bind="userEditLayout">
                  <a-select
                          style="width: 100%"
                          size="small"
                          allowClear
                          :placeholder="$t('publicLang.PleaseSelect')"
                          v-decorator="[
                      'timeZone',
                      {
                        rules: [{ required: true, message: $t('publicLang.Required') }]
                      }
                    ]">
                    <a-select-option
                            v-for="(ii, index) in userItmezone"
                            :value="ii.key"
                            :key="index"
                    >{{ ii.englishName }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.defaultOrg')" v-bind="userEditLayout">
                  <a-input
                          size="small"
                          :placeholder="$t('userlang.defaultOrg')"
                          v-decorator="[
                    'orgCode'
                  ]"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('userlang.defaultProj')" v-bind="userEditLayout">
                  <a-input
                          size="small"
                          :placeholder="$t('userlang.defaultProj')"
                          v-decorator="[
                    'defaultProjCode'
                  ]"/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-collapse-panel>
        </a-collapse>
      </a-form>

    </a-modal>
    <!--编辑 权限-->
    <a-drawer
            :title="$t('userlang.EditUser')"
            placement="right"
            :closable="true"
            :maskClosable="NomaskClosable"
            @close="onCloseDrawer"
            :visible="DrawerVisible"
            width="90%"
    >
      <a-tabs defaultActiveKey="1">
        <a-tab-pane :tab="$t('userlang.Edit')" key="1">
          <a-form  style='margin-top: 15px' :form="form" v-if="userEditData != ''">
            <a-collapse v-model="activeKey"  :bordered="false">
              <a-collapse-panel key="1" header="Main">
                <a-row :gutter="24">
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.UserAccount')" v-bind="userEditLayout">
                      <a-input
                              size="small"
                              :placeholder="$t('userlang.UserAccount')"
                              disabled
                              v-decorator="[
                    'userAccount',
                    {
                      initialValue: userEditData.user.userAccount
                    }
                  ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.Email')" v-bind="userEditLayout">
                      <a-input
                              size="small"
                              :placeholder="$t('userlang.Email')"
                              v-decorator="[
                        'email',
                        {
                          initialValue: userEditData.user.email,
                           rules: [
                              {
                                type: 'email',
                                message: $t('publicLang.PleaseinputEmail')
                              },
                              {
                                required: true,
                                message: $t('publicLang.PleaseinputEmail')
                              },
                            ],
                        }
                    ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item v-bind="userEditLayout" :label="$t('userlang.FirstName')">
                      <a-input
                              size="small"
                              autocomplete="off"
                              :placeholder="$t('userlang.FirstName')"
                              style="width: 100%"
                              v-decorator="[
                      'firstName',
                      {
                        initialValue: userEditData.user.firstName,
                        rules: [{ required: true, message: $t('publicLang.Required') }]
                      }
                    ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item v-bind="userEditLayout" :label="$t('userlang.MiddleName')">
                      <a-input
                              :placeholder="$t('userlang.MiddleName')"
                              autocomplete="off"
                              size="small"
                              style="width: 100%"
                              v-decorator="[
                      'middleName',
                      {
                        initialValue: userEditData.user.middleName
                      }
                    ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item v-bind="userEditLayout" :label="$t('userlang.LastName')">
                      <a-input
                              :placeholder="$t('userlang.LastName')"
                              autocomplete="off"
                              style="width: 100%"
                              size="small"
                              v-decorator="[
                        'lastName',
                        {
                          initialValue: userEditData.user.lastName,
                          rules: [{ required: true, message: $t('publicLang.Required') }]
                        }
                      ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item v-bind="userEditLayout" :label="$t('userlang.DisplayName')">
                      <a-input
                              :placeholder="$t('userlang.DisplayName')"
                              autocomplete="off"
                              style="width: 100%"
                              size="small"
                              v-decorator="[
                      'dispName',
                      {
                        initialValue: userEditData.user.dispName,
                        rules: [{ required: true, message: $t('publicLang.Required') }]
                      }
                      ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('login.Username')" v-bind="userEditLayout">
                      <a-input
                              autocomplete="off"
                              size="small"
                              style="width: 100%"
                              :placeholder="$t('publicLang.PleaseEnter')"
                              v-decorator="[
                      'username',
                      {
                        initialValue: userEditData.user.username,
                        rules: [{ required: true, message: $t('publicLang.Required') }]
                      }
                    ]"/>
                    </a-form-item>
                  </a-col>

                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.domain')" v-bind="userEditLayout">
                      <a-input
                        autocomplete="off"
                        size="small"
                        style="width: 100%"
                        :placeholder="$t('userlang.domain')"
                        v-decorator="[
                      'domain',
                      {
                        initialValue: userEditData.user.domain
                      }
                    ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.useredQr')" v-bind="userEditLayout">
                      <a-select v-decorator="['useredQr',{initialValue: userEditData.user.useredQr == null ? undefined : userEditData.user.useredQr}]" style="width: 100%" size="small" allowClear>
                        <a-select-option value="Y">Y</a-select-option>
                        <a-select-option value="N">N</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-collapse-panel>
              <a-collapse-panel key="2" header="Contact">
                <a-row :gutter="24">
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.Company')" v-bind="userEditLayout">
                      <a-input
                              :placeholder="$t('userlang.Company')"
                              autocomplete="off"
                              style="width: 100%"
                              size="small"
                              v-decorator="[
                      'companyName',
                      {
                        initialValue: userEditData.user.companyName,
                      }
                    ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.Department')" v-bind="userEditLayout">
                      <a-input
                              autocomplete="off"
                              style="width: 100%"
                              size="small"
                              :placeholder="$t('userlang.Department')"
                              v-decorator="[
                    'departName',
                    {
                      initialValue: userEditData.user.departName,
                    }
                ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.Position')" v-bind="userEditLayout">
                      <a-input
                              autocomplete="off"
                              style="width: 100%"
                              size="small"
                              :placeholder="$t('userlang.Position')"
                              v-decorator="[
                        'position',
                        {
                          initialValue: userEditData.user.position,
                        }
                      ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.Telephone')" v-bind="userEditLayout">
                      <a-input
                              autocomplete="off"
                              style="width: 100%"
                              size="small"
                              :placeholder="$t('userlang.Telephone')"
                              v-decorator="[
                      'telNum',
                      {
                        initialValue: userEditData.user.telNum,
                      }
                    ]"/>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-collapse-panel>
              <a-collapse-panel key="3" header="Address">
                <a-row :gutter="24">
                  <a-col :span="8" v-if="false">
                    <a-form-item :label="$t('userlang.Orgnization')" v-bind="userEditLayout" v-if="userEditData.systemAdminMark">
                      <a-select
                              style="width: 100%"
                              size="small"
                              :placeholder="$t('publicLang.PleaseSelect')"
                              v-decorator="[
                            'orgCode',
                            {
                          initialValue: userEditData.user.orgCode == null ? undefined : userEditData.user.orgCode,
                          rules: [{ required: true, message: $t('publicLang.Required') }]
                        }
                      ]">
                        <a-select-option v-for="item in userEditData.OrganizationList" :value="item.orgCode">{{item.displayName}}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.Address1')" v-bind="userEditLayout">
                      <a-input
                              size="small"
                              :placeholder="$t('userlang.Address1')"
                              v-decorator="[
                    'address1',
                    {
                      initialValue: userEditData.user.address1
                    }
                  ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.Address2')" v-bind="userEditLayout">
                      <a-input
                              size="small"
                              :placeholder="$t('userlang.Address2')"
                              v-decorator="[
                    'address2',
                    {
                      initialValue: userEditData.user.address2
                    }
                  ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.Address3')" v-bind="userEditLayout">
                      <a-input
                              size="small"
                              :placeholder="$t('userlang.Address3')"
                              v-decorator="[
                    'address3',
                    {
                      initialValue: userEditData.user.address3
                    }
                  ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.Address4')" v-bind="userEditLayout">
                      <a-input
                              size="small"
                              :placeholder="$t('userlang.Address4')"
                              v-decorator="[
                    'address4',
                    {
                      initialValue: userEditData.user.address4
                    }
                  ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.Postal')" v-bind="userEditLayout">
                      <a-input
                              size="small"
                              :placeholder="$t('userlang.Postal')"
                              v-decorator="[
                    'postal',
                    {
                      initialValue: userEditData.user.postal
                    }
                  ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.Street')" v-bind="userEditLayout">
                      <a-input
                              size="small"
                              :placeholder="$t('userlang.Street')"
                              v-decorator="[
                    'street',
                    {
                      initialValue: userEditData.user.street
                    }
                  ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.District')" v-bind="userEditLayout">
                      <a-input
                              size="small"
                              :placeholder="$t('userlang.District')"
                              v-decorator="[
                    'district',
                    {
                      initialValue: userEditData.user.district
                    }
                  ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.Latitude')" v-bind="userEditLayout">
                      <a-input
                              size="small"
                              :placeholder="$t('userlang.Latitude')"
                              v-decorator="[
                    'latitude',
                    {
                      initialValue: userEditData.user.latitude
                    }
                  ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.Longitude')" v-bind="userEditLayout">
                      <a-input
                              size="small"
                              :placeholder="$t('userlang.Longitude')"
                              v-decorator="[
                    'longitude',
                    {
                      initialValue: userEditData.user.longitude
                    }
                  ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.Country')" v-bind="userEditLayout">
                      <a-input
                              size="small"
                              :placeholder="$t('userlang.Country')"
                              v-decorator="[
                    'country',
                    {
                      initialValue: userEditData.user.country
                    }
                  ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.City')" v-bind="userEditLayout">
                      <a-cascader
                              :options="cityOptions"
                              size="small"
                              @change="cityChange"
                              :loadData="cityLoadData"
                              :placeholder="$t('publicLang.PleaseSelect')"
                              changeOnSelect
                              :fieldNames="{ value: 'ebplCode', label: 'ebplNameEn', children: 'children' }"
                              v-if="isEditCity"
                      />
                      <div v-else>
                        <span >{{userEditData.user.address == '' ? '---' : userEditData.user.address}}</span>
                        <img @click="isEditCityEvent" class="sbxs ml4" src="../../assets/img/ss-edit.png"  width="22" height="22">
                      </div>

                    </a-form-item>
                  </a-col>
                </a-row>
              </a-collapse-panel>
              <a-collapse-panel key="4" header="Parameter">
                <a-row :gutter="24">
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.Language')" v-bind="userEditLayout">
                      <a-select
                              style="width: 100%"
                              size="small"
                              allowClear
                              :placeholder="$t('publicLang.PleaseSelect')"
                              v-decorator="[
                    'defaultLang',
                    {
                      initialValue: userEditData.user.defaultLang  == null ? undefined : userEditData.user.defaultLang ,
                      rules: [{ required: true, message: $t('publicLang.Required') }]
                    }
                  ]">
                        <a-select-option value="0">{{ $t('userlang.Jtlang') }}</a-select-option>
                        <a-select-option value="1">{{ $t('userlang.ftlang')}}</a-select-option>
                        <a-select-option value="2">English</a-select-option>
                        <a-select-option value="3">{{ $t('userlang.korlang')}}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.TimeZone')" v-bind="userEditLayout">
                      <a-select
                              show-search
                              optionFilterProp="label"
                              style="width: 100%"
                              size="small"
                              allowClear
                              :placeholder="$t('publicLang.PleaseSelect')"
                              v-decorator="[
                      'timeZone',
                      {
                        initialValue: userEditData.user.timeZone == null ? undefined : userEditData.user.timeZone,
                        rules: [{ required: true, message: $t('publicLang.Required') }]
                      }
                    ]">
<!--                        <a-select-option v-for="(ii, index) in userItmezone" :value="ii.key" :key="index">{{ ii.englishName }}</a-select-option>-->
                        <a-select-option :label="ii.englishName"  :value="ii.key" :key="index" v-for="(ii, index) in userItmezone">{{ii.englishName}}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.defaultOrg')" v-bind="userEditLayout">
                      <a-input
                              size="small"
                              :placeholder="$t('userlang.defaultOrg')"
                              v-decorator="[
                    'orgCode',
                    {
                      initialValue: userEditData.user.orgCode
                    }
                  ]"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item :label="$t('userlang.defaultProj')" v-bind="userEditLayout">
                      <a-input
                              size="small"
                              :placeholder="$t('userlang.defaultProj')"
                              v-decorator="[
                    'defaultProjCode',
                    {
                      initialValue: userEditData.user.defaultProjCode
                    }
                  ]"/>
                    </a-form-item>
                  </a-col>




                  <a-col :span="8" class="default-proj-reset-button-col">
                    <a-button
                      class="default-proj-reset-button"
                      size="small"
                      type="primary"
                      @click="resetPasswords"
                    >{{ $t('pubGicSet.ResetPasswordsButton') }}</a-button>
                  </a-col>



                </a-row>
              </a-collapse-panel>
            </a-collapse>
          </a-form>

          <a-tabs>
            <a-tab-pane key="1">
              <span slot="tab">Organization</span>
              <a-row style="margin: 20px 0">
                <img @click="addPJWH('OG')" class="sbxs mr4" src="../../assets/img/ss-add.png"  width="22" height="22">
                <a-popconfirm
                        :title="$t('pubGicSet.AreyoudeleTask')"
                        :okText="$t('pubGicSet.Yes')"
                        :cancelText="$t('pubGicSet.No')"
                        @confirm="deletePJWH('OG')"
                >
                  <a-tooltip placement="topLeft">
                    <template slot="title">
                      <span>{{ $t('userlang.Delete') }}</span>
                    </template>
                    <img class="sbxs" src="../../assets/img/ss-delete.png"  width="22" height="22">
                  </a-tooltip>
                </a-popconfirm>
              </a-row>
              <vxe-table
                      stripe
                      highlight-hover-row
                      border
                      resizable
                      size="mini"
                      ref="orgTableRef"
                      class="vxe-table-antd"
                      :data="userEditData.organizations"
                      max-height="250"
              >
                <template v-slot:empty>
                  <span style="font-size: 12px; color: red;">{{ $t('userlang.NorecordFound') }}</span>
                </template>
                <vxe-table-column  type="checkbox" width="60"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="orgCode" title="Organization"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="displayName" title="Display Name"></vxe-table-column>
              </vxe-table>

            </a-tab-pane>
            <a-tab-pane key="2">
              <span slot="tab">{{ $t('userlang.Project') }}</span>
              <a-row style="margin: 20px 0">
                <img @click="addPJWH('PJ')" class="sbxs mr4" src="../../assets/img/ss-add.png"  width="22" height="22">
                <a-popconfirm
                    :title="$t('pubGicSet.AreyoudeleTask')"
                    :okText="$t('pubGicSet.Yes')"
                    :cancelText="$t('pubGicSet.No')"
                    @confirm="deletePJWH('PJ')"
                >
                  <a-tooltip placement="topLeft">
                    <template slot="title">
                      <span>{{ $t('userlang.Delete') }}</span>
                    </template>
                    <img class="sbxs" src="../../assets/img/ss-delete.png"  width="22" height="22">
                  </a-tooltip>
                </a-popconfirm>
              </a-row>
              <vxe-table
                      stripe
                      highlight-hover-row
                      border
                      resizable
                      size="mini"
                      ref="preojectTable"
                      class="vxe-table-antd"
                      :data="userEditData.products"
                      max-height="250"
              >
                <template v-slot:empty>
                  <span style="font-size: 12px; color: red;">{{ $t('userlang.NorecordFound') }}</span>
                </template>
                <vxe-table-column  type="checkbox" width="60"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="projectCode" :title="$t('reportSetting.ProjectCode')"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="projectName" :title="$t('reportSetting.ProjectName')"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="orgName" :title="$t('userlang.Organization')"></vxe-table-column>
              </vxe-table>
            </a-tab-pane>
            <a-tab-pane key="3">
              <span slot="tab">{{$t('userlang.Warehouse')}}</span>
              <a-row style="margin: 20px 0">
                <img @click="addPJWH('WH')" class="sbxs mr4" src="../../assets/img/ss-add.png"  width="22" height="22">
                <a-popconfirm
                        :title="$t('pubGicSet.AreyoudeleTask')"
                        :okText="$t('pubGicSet.Yes')"
                        :cancelText="$t('pubGicSet.No')"
                        @confirm="deletePJWH('WH')"
                >
                  <a-tooltip placement="topLeft">
                    <template slot="title">
                      <span>{{$t('userlang.Delete')}}</span>
                    </template>
                    <img class="sbxs" src="../../assets/img/ss-delete.png"  width="22" height="22">
                  </a-tooltip>
                </a-popconfirm>
              </a-row>
              <vxe-table
                      stripe
                      highlight-hover-row
                      border
                      resizable
                      size="mini"
                      ref="wareTable"
                      :data="userEditData.warehouses"
                      max-height="250"
              >
                <template v-slot:empty>
                  <span style="font-size: 12px; color: red;">{{$t('userlang.NorecordFound')}}</span>
                </template>
                <vxe-table-column  type="checkbox" width="60"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="whsCode" :title="$t('pubGicSet.WarehouseCode')"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="whsName" :title="$t('userlang.WarehouseName')"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="address" :title="$t('userlang.Address')"></vxe-table-column>
              </vxe-table>
            </a-tab-pane>

          </a-tabs>
          <div style="float: right;margin-top: 10px;">
            <a-button type="primary" @click="getUserInfo" :loading="userGetLoading">{{ $t('userlang.Save') }}</a-button>
          </div>

        </a-tab-pane>
        <a-tab-pane :tab="$t('userlang.AccessRights')" key="2" forceRender>
          <a-row type="flex" justify="start" style="margin-top: 10px;">
            <a-col>
              <a-form :form="roleForm">
                <a-form-item :label="$t('userlang.Role')" v-bind="formItemLayout">
                  <a-select
                      show-search
                      optionFilterProp="label"
                      size="small"
                      :placeholder="$t('userlang.Pleaseselect')"
                      style="width: 220px"
                      allowClear
                      v-decorator="[
                      'roleid',
                      {
                        rules: [{ required: false, message:  $t('publicLang.Required')  }]
                      }
                    ]">
                    <a-select-option :label="item.roleName"  :value="item.uid" :key="item.uid" v-for="item in roleListData">{{item.roleName}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-form>
            </a-col>
            <a-col >
              <a-button 
              style="margin-left: 20px;"
                  size="small"
                  type="primary"
                  shape="circle"
                  icon="plus"
                  @click="copyRoleAuthority"
              >
              </a-button>
            </a-col>
          </a-row>
    
 <a-row>
     <ul > 
            <li class="role_li" v-for="item in this.selectedRole">
              <span style="padding: 0 8px;color: white;"> {{item.roleName}}</span> 
              <a href="javascript:void(0)" class="role_del" @click="deleteUserRole(item.uid)"> </a> 
            </li>
        </ul>
 </a-row>


          <div style="overflow-y: auto;height: 65vh;">
            <a-spin :spinning="spinning">
              <a-directory-tree
                  checkable
                  @select="onSelect"
                  :showIcon="false"
                  :treeData="treeUserData"
                  v-model="checkedKeys"
                  :checkedKeys="checkedKeys"
              >
              </a-directory-tree>
            </a-spin>
          </div>
          
          <a-button size="small" type="primary" @click="checkUserTree" style="float: right;margin-top: 10px;">{{ $t('userlang.Save') }}</a-button>

           
        <a-button size="small" type="primary"  style="float: right;margin-top: 10px;margin-right: 15px;"  @click="resetChanges"  v-if="resetChangesFlag" >
                Reset Changes
         </a-button>

                      
        </a-tab-pane>
      </a-tabs>
    </a-drawer>

    <a-modal :title="$t('userlang.AddProject')" v-model="addProjectVis" width="50%">
      <template slot="footer">
        <a-button @click="addProWhTable('PJ')"  type="primary">{{ $t('userlang.Save') }}</a-button>
      </template>
      <a-input
              v-model="addProjectQueryInput"
              size="small"
              allowClear
              :placeholder="$t('publicLang.PleaseEnter')"
              style="width: 220px; margin-bottom: 10px;"
              @pressEnter="searchAddProject"
      />
      <vxe-table
              stripe
              highlight-hover-row
              border
              resizable
              size="mini"
              ref="AddProjectTable"
              :data="filteredAddProjectTable"
              max-height="250"
      >
        <template v-slot:empty>
          <span style="font-size: 12px; color: red;">{{ $t('userlang.NorecordFound') }}</span>
        </template>
        <vxe-table-column  type="checkbox" width="60"></vxe-table-column>
        <vxe-table-column min-width="160" show-header-overflow="ellipsis" show-overflow="ellipsis" field="projectCode" :title="$t('reportSetting.ProjectCode')"></vxe-table-column>
        <vxe-table-column min-width="160" show-header-overflow="ellipsis" show-overflow="ellipsis" field="ProjectName" :title="$t('reportSetting.ProjectName')"></vxe-table-column>
      </vxe-table>
    </a-modal>

    <a-modal :title="$t('userlang.AddWarehouse')" v-model="addWareVis" width="50%">
      <template slot="footer">
        <a-button @click="addProWhTable('WH')"  type="primary">{{ $t('userlang.Save') }}</a-button>
      </template>
      <a-input
              v-model="addWarehouseQueryInput"
              size="small"
              allowClear
              :placeholder="$t('publicLang.PleaseEnter')"
              style="width: 220px; margin-bottom: 10px;"
              @pressEnter="searchAddWarehouse"
      />
      <vxe-table
              stripe
              highlight-hover-row
              border
              resizable
              size="mini"
              ref="AddwareTable"
              :data="filteredAddWareTable"
              max-height="250"
      >
        <template v-slot:empty>
          <span style="font-size: 12px; color: red;">{{ $t('userlang.NorecordFound') }}</span>
        </template>
        <vxe-table-column  type="checkbox" width="60"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="whsCode" :title="$t('pubGicSet.WarehouseCode')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="whsName" :title="$t('userlang.WarehouseName')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="whsAddress1" :title="$t('userlang.Address')"></vxe-table-column>
      </vxe-table>
    </a-modal>

    <a-modal title="Organization" v-model="addOrgVis" width="50%">
      <template slot="footer">
        <a-button  type="primary" @click="addProWhTable('OG')" >{{ $t('userlang.Save') }}</a-button>
      </template>
      <a-input
              v-model="addOrganizationQueryInput"
              size="small"
              allowClear
              :placeholder="$t('publicLang.PleaseEnter')"
              style="width: 220px; margin-bottom: 10px;"
              @pressEnter="searchAddOrganization"
      />
      <vxe-table
              stripe
              highlight-hover-row
              border
              resizable
              size="mini"
              :data="filteredAddOrgTable"
              ref="orgAddTableRef"
              max-height="250"
      >
        <template v-slot:empty>
          <span style="font-size: 12px; color: red;">{{ $t('userlang.NorecordFound') }}</span>
        </template>
        <vxe-table-column  type="checkbox" width="60"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="orgCode" title="Organization"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="displayName" title="Display Name"></vxe-table-column>
      </vxe-table>
    </a-modal>

    <a-modal
        title="Batch Update"
        :visible="batchUpdateVis"
        width="50%"
        @cancel="cancelBatchUpdate"
    >
      <template slot="footer">
        <a-button size="small" type="primary" @click="userBatchUpdate">Save</a-button>
      </template>
      <a-form  :form="batchUpdateForm">
        <a-row>
          <a-col>
            <a-form-item :label="$t('userlang.City')" v-bind="userEditLayout">
              <a-cascader
                    :options="cityOptions"
                    size="small"
                    @change="cityChange"
                    :loadData="cityLoadData"
                    :placeholder="$t('publicLang.PleaseSelect')"
                    changeOnSelect
                    :fieldNames="{ value: 'ebplCode', label: 'ebplNameEn', children: 'children' }"
                    v-decorator="[ 'city']"
              />
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item :label="$t('userlang.Language')" v-bind="userEditLayout">
              <a-select
                    style="width: 100%"
                    size="small"
                    allowClear
                    :placeholder="$t('publicLang.PleaseSelect')"
                    v-decorator="['defaultLang']">
                <a-select-option value="0">{{ $t('userlang.Jtlang') }}</a-select-option>
                <a-select-option value="1">{{ $t('userlang.ftlang')}}</a-select-option>
                <a-select-option value="2">English</a-select-option>
                <a-select-option value="3">{{ $t('userlang.korlang')}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item :label="$t('userlang.TimeZone')" v-bind="userEditLayout">
              <a-select
                      style="width: 100%"
                      size="small"
                      allowClear
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="['timeZone']">
                <a-select-option
                        v-for="(ii, index) in userItmezone"
                        :value="ii.key"
                        :key="index"
                >{{ ii.englishName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item :label="$t('userlang.Role')" v-bind="userEditLayout">
              <a-select
                      size="small"
                      :placeholder="$t('userlang.Pleaseselect')"
                      style="width: 100%"
                      allowClear
                      v-decorator="['roleid']">
                <a-select-option
                        v-for="item in roleListData"
                        :key="item.uid"
                >{{ item.roleName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>


  <user-import :visible="importVisible" v-on:cancelImport="cancelImport"></user-import>
    
  </div>
</template>
<script>
    import ajax from "../../api/ajax";
    import api from "../../api/url";
    import { mapState } from "vuex";
    import tableComs from "../com/tableComs.vue";
    import userImport from "../masterData/components/userImport.vue";
    import cookie from '../../api/cookie';     

    export default {
        components:{
            tableComs,
            userImport
        },
        data() {
            return{
                importparams:{},
                importVisible: false,
                CreateUserVis: false, // 添加user
                batchUpdateVis: false,
                addProjectVis: false,
                addWareVis: false,
                addProjectTable: [],
                addWareTable: [],
                addProjectQueryInput: '',
                addProjectQuery: '',
                addWarehouseQueryInput: '',
                addWarehouseQuery: '',
                addOrgVis: false,
                addOrgTable: [],
                addOrganizationQueryInput: '',
                addOrganizationQuery: '',
                activeKey:['1'],
                data:{},
                tableSelectBox: [],
                formItemLayout: {
                    labelCol: {
                        xs: { span: 4},
                        sm: { span: 4}
                    },
                    wrapperCol: {
                        xs: { span: 8 },
                        sm: { span: 16 }
                    }
                },
//         gericTable
                substr: 0,
                fixedNum: 0,
                parloading: true,
                tableGmcuid: '',
                MaxHeight: 0,
                TitleSearchVal: [],
                pageInfoType: '',
                initRenderFnSearchParamsArr: {
                    SortValArr: [],
                    titleSearchArr: [],
                    andvanSearchArr: []
                },
//         分页
                pageSizeOptions:['10', '20', '30', '40','100','500','1000'],
                pagingTotal: 50,
                currentVal: 1,
                pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30'),
                parTableTemplateSelect:[],
                parTableTemplateName:null,

//         弹窗参数
                DrawerVisible: false,
                NomaskClosable: false,
                userEditLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                createUserform: this.$form.createForm(this),
                form: this.$form.createForm(this),
                roleForm: this.$form.createForm(this),
                batchUpdateForm: this.$form.createForm(this),
                userEditData: "",
                selectWarehouseRowKeys: [],
                cityOptions: [],
                cityArr: [],
                isEditCity: false,
                userGetLoading: false,
                editUserUid: '',
                userItmezone: [],
                resetChangesFlag: false,

//         权限
                //        树结构数据
                treeUserData: [], // 树的数据
                checkedKeys: [], // 默认选中
                selectedKeys: [], // 选中的数据
                roleListData: [],
                 selectedRole:[], // 选中的角色数据
                spinning: false,
            }
        },
        computed: {
            ...mapState(["lang"]),
            ...mapState(["Role"]),
            filteredAddProjectTable() {
                return this.filterRecords(this.addProjectTable, this.addProjectQuery, ['projectCode', 'ProjectName']);
            },
            filteredAddWareTable() {
                return this.filterRecords(this.addWareTable, this.addWarehouseQuery, ['whsCode', 'whsName']);
            },
            filteredAddOrgTable() {
                return this.filterRecords(this.addOrgTable, this.addOrganizationQuery, ['orgCode', 'displayName']);
            },
        },
        $route() {
            this.initData();
        },
        created() {
            this.initData()
            this.MaxHeight = document.body.clientHeight - 160;
        },
        methods:{
          sortRecords(records, field) {
              return (records || []).slice().sort((left, right) => {
                  const leftValue = left[field] == null ? '' : String(left[field]);
                  const rightValue = right[field] == null ? '' : String(right[field]);
                  return leftValue.localeCompare(rightValue, undefined, { sensitivity: 'base' });
              });
          },
          filterRecords(records, keyword, fields) {
              if (!keyword) {
                  return records;
              }
              const normalizedKeyword = keyword.toLowerCase();
              return records.filter(record => fields.some(field =>
                  String(record[field] || '').toLowerCase().includes(normalizedKeyword)
              ));
          },
          searchAddProject() {
              this.addProjectQuery = this.addProjectQueryInput.trim();
          },
          searchAddWarehouse() {
              this.addWarehouseQuery = this.addWarehouseQueryInput.trim();
          },
          searchAddOrganization() {
              this.addOrganizationQuery = this.addOrganizationQueryInput.trim();
          },
          popUpImport(){
              this.importVisible = true          
          },
          resetChanges() {
                 let that = this;
                this.$customConfirm({
                    title: this.$i18n.t('pubGicSet.UserResetChanges'),
                    okText: this.$i18n.t('pubGicSet.Yes'),
                    okType: 'confirm',
                    cancelText: this.$i18n.t('pubGicSet.No'),
                    onOk() {
                         ajax.get(api.USERRESETCHANGES, {uid: that.editUserUid}).then(res => {
                           if (res.code == 200) {
                              that.$message.success(res.msg);
                               that.spinning = false
                               that.treeAjaxData();
                           }else{
                               that.$customMessage.warning(res.msg);
                           }
                       });
                    },
                    onCancel() {
                      console.log('Cancel');
                    },
                });
          },
          deleteUserRole(roleUid){
                // 请求删除权限
          let params = {
                    userUids: [this.editUserUid],
                    roleUid: roleUid
                }
           ajax.post(api.USERREMOVEROLE, params).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                      // this.findRoleByUser();
                      this.treeAjaxData();
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                });



           },
              cancelImport(val) {
                this.importVisible = false;
                 this.initData()
            },
//            保存添加user
            saveCreateUser(){
                this.createUserform.validateFields((err,val)=>{
                    if (!err) {
                        let params = val;
                        params.city = this.cityArr
                        ajax.put(api.USER, params).then(res => {
                            if (res.code == 200) {
                                this.CreateUserVis = false
                                this.initRenderFn()
                                this.$message.success(res.msg);
                                this.cityArr = []
                            }else{
                                this.$customMessage.error(res.msg);
                                return
                            }
                        })
                    }
                })
            },
//            添加user
            createUser(){
              this.CreateUserVis = true
              this.createUserform.resetFields();
              this.cityArr = []
              ajax.get(api.TIMEZONE).then(res => {
                  this.userItmezone = res.data
              });
              //               城市
              let param = {
                  addressType:0,
                  address:"",
                  lang:1
              }
              ajax.post(api.GETUSERADDRESS,param).then(res=>{
                  this.cityOptions = res.data
                  for(let i in this.cityOptions){
                      this.cityOptions[i].isLeaf = false
                  }
              })
            },

            cleardata(){
                this.data = []
                this.initData();
            },
//            Refresh
            handleToolClick(){
                this.parTableTemplateName  = 'all'
                this.parloading = true;
                let jsonArray = {};
                jsonArray.gmcUid = this.tableGmcuid;
                this.pageInfoType = "qf";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.andvanSearchArr = jsonArray;
                this.initRenderFnSearchParamsArr.titleSearchArr = [];
                this.initRenderFn('all');
            },
            cancelBatchUpdate(){
                this.batchUpdateVis = false
            },
//            save batch update
            userBatchUpdate(){
                this.batchUpdateForm.validateFields((err, values) => {
                    if (!err) {
                        let arr = []
                        for(let i in this.tableSelectBox){
                            arr.push(this.tableSelectBox[i].uid)
                        }
                      if(values.city == undefined && values.defaultLang == undefined && values.roleid == undefined && values.timeZone == undefined){
                          this.$customMessage.warning(this.$t('publicLang.PleaseOneLeast'));
                          return
                      }
                        let params = {
                            "city": values.city,
                            "language":values.defaultLang,
                            "roleUid": values.roleid,
                            "timeZone": values.timeZone,
                            "userUids": arr
                        }
                        ajax.post(api.USERBATCHUPDATE,params).then(res=>{
                            if(res.code == 200){
                                this.batchUpdateVis = false

                                this.$message.success(res.msg);
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }
                });
            },
//            batch Update 弹窗
          batchUpdata(){
                if(this.tableSelectBox.length > 0){
                    ajax.get(api.TIMEZONE).then(res => {
                        this.userItmezone = res.data
                    });
                    let param = {
                        addressType:0,
                        address:"",
                        lang:1
                    }
                    ajax.post(api.GETUSERADDRESS,param).then(res=>{
                        this.cityOptions = res.data
                        for(let i in this.cityOptions){
                            this.cityOptions[i].isLeaf = false
                        }
                    })
                    ajax.get(api.USERROLE).then(res => {
                        this.roleListData = res.data;
                    });
                    this.batchUpdateVis = true
                    this.batchUpdateForm.resetFields();
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
                }
          },
           skuTableTemplateData(val){
                this.clearImportUids();
                 this.parTableTemplateName  = val
                this.parloading = true;
                let jsonArray = {};
                jsonArray.gmcUid = this.tableGmcuid;
                this.pageInfoType = "qf";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.andvanSearchArr = jsonArray;
                this.initRenderFn();
            },
//      删除project warehose
            deletePJWH(type){
                if (type == "PJ") {
                    let pjTable = this.$refs.preojectTable.getCheckboxRecords()
                    if (pjTable.length < 1) {
                        this.$customMessage.warning(this.$t('userlang.PleaseOneleast'))
                        return;
                    }
                    let checkuid = [];
                    pjTable.forEach(value => {
                        checkuid.push(value.uid);
                    });
                    let params = {
                        uids: checkuid,
                        userUid: this.editUserUid
                    }
                    ajax.post(api.DELETEPROJECT, params).then(res => {
                        if (res.code == 200) {
                            this.editInit();
                            this.$message.success(res.msg);
                        }else{
                            this.$customMessage.error(res.msg);
                        }
                    });
                }else if (type == "WH"){
                    let pjTable = this.$refs.wareTable.getCheckboxRecords()
                    if (pjTable.length < 1) {
                        this.$customMessage.warning(this.$t('userlang.PleaseOneleast'));
                        return;
                    }
                    let checkuid = [];
                    pjTable.forEach(value => {
                        checkuid.push(value.uid);
                    });
                    let params = {
                        uids: checkuid,
                        userUid: this.editUserUid
                    };

                    ajax.post(api.USERDELETEWHS, params).then(res => {
                        if (res.code == 200) {
                            this.editInit();
                            this.$message.success(res.msg);
                        }else{
                            this.$customMessage.error(res.msg);
                        }
                    });
                }else if(type == "OG"){
                    let OgTable = this.$refs.orgTableRef.getCheckboxRecords()
                    if (OgTable.length < 1) {
                        this.$customMessage.warning(this.$t('userlang.PleaseOneleast'));
                        return;
                    }
                    let checkuid = [];
                    OgTable.forEach(value => {
                        checkuid.push(value.uid);
                    });
                    let params = {
                        uids: checkuid,
                        userUid: this.editUserUid
                    };

                    ajax.post(api.USERDELETEORG, params).then(res => {
                        if (res.code == 200) {
                            this.editInit();
                            this.$message.success(res.msg);
                        }else{
                            this.$customMessage.error(res.msg);
                        }
                    });
                }
            },
//       add project warehose
            addPJWH(type){
                if (type == "PJ"){
                    ajax.get(api.PROJECT, {uid: this.editUserUid}).then(res=>{
                        this.addProjectQueryInput = ''
                        this.addProjectQuery = ''
                        this.addProjectVis = true
                        this.addProjectTable = this.sortRecords(res.data, 'projectCode')
                    })
                }else if(type == "OG"){
                    ajax.get(api.USERORGAddLIST, {uid: this.editUserUid}).then(res=>{
                        this.addOrganizationQueryInput = ''
                        this.addOrganizationQuery = ''
                        this.addOrgVis = true
                        this.addOrgTable = this.sortRecords(res.data, 'orgCode')
                    })
                }else{
                    ajax.get(api.WHS, {uid: this.editUserUid}).then(res=>{
                        this.addWarehouseQueryInput = ''
                        this.addWarehouseQuery = ''
                        this.addWareVis = true
                        this.addWareTable = this.sortRecords(res.data, 'whsCode')
                    })
                }
            },
            addProWhTable(type){
                let params = {
                    uids: [],
                    userUid: this.editUserUid
                };
                if (type == "PJ"){
                    let selectRecords = this.$refs.AddProjectTable.getCheckboxRecords()
                    if(selectRecords.length > 0){
                        selectRecords.forEach(value => {
                            params.uids.push(value.uid);
                        });
                        ajax.post(api.PROJECT, params).then(res => {
                            if (res.code == 200) {
                                this.addProjectVis = false
                                this.editInit()
                            }
                        });
                    }else{
                        this.$customMessage.error(this.$t('userlang.PleaseOneleast'));
                        return
                    }
                }else if(type == "OG"){
                    let selectRecords = this.$refs.orgAddTableRef.getCheckboxRecords()
                    if(selectRecords.length > 0){
                        selectRecords.forEach(value => {
                            params.uids.push(value.uid);
                        });
                        ajax.post(api.USERORGAddLIST, params).then(res => {
                            if (res.code == 200) {
                                this.addOrgVis = false
                                this.editInit()
                            }
                        });
                    }else{
                        this.$customMessage.error(this.$t('userlang.PleaseOneleast'));
                        return
                    }

                }else{
                    let selectRecords = this.$refs.AddwareTable.getCheckboxRecords()
                    if(selectRecords.length > 0){
                        selectRecords.forEach(value => {
                            params.uids.push(value.uid);
                        });
                        ajax.post(api.WHS, params).then(res => {
                            if (res.code == 200) {
                                this.addWareVis = false;
                                this.editInit()
                            }
                        });
                    }else{
                        this.$customMessage.error(this.$t('userlang.PleaseOneleast'));
                        return
                    }
                }
            },
          resetPasswords(){
            const currentEditUid = this.editUserUid || (this.userEditData && this.userEditData.user && this.userEditData.user.uid);
            if(!currentEditUid){
              this.$customMessage.error(this.$t('userlang.PleaseOneleast'));
              return;
            }
            let params = {
              uids: [currentEditUid]
            };
            this.$customConfirm({
              title: this.$i18n.t('pubGicSet.ResetPasswordsConfirm'),
              okText: this.$i18n.t('pubGicSet.Yes'),
              okType: 'confirm',
              cancelText: this.$i18n.t('pubGicSet.No'),
              onOk: () => {
                ajax.post(api.USERRESETPASSWORDS, params).then(res => {
                  if (res.code == 200) {
                    // this.initRenderFn();
                    this.$message.success(res.msg);
                  } else {
                    this.$customMessage.error(res.msg);
                  }
                })
              }
            })
          },
//      头部按钮请求
            logoutEffectAjax(type) {
                let checkuid = [];
                this.tableSelectBox.forEach(v => {
                    checkuid.push(v.uid);
                });
                let params = {
                    modifier: "",
                    status: type,
                    uids: checkuid
                };
                ajax.put(api.USERSTAS, params).then(res => {
                    if (res.code == 200) {
                        this.initRenderFn();
                    }
                });
            },
            logoutEffect(type){
                if (type == "logout") {
                    if (this.tableSelectBox.length < 1) {
                        this.$customMessage.error(this.$t('userlang.PleaseOneleast'));
                        return;
                    }
                    this.logoutEffectAjax(0);
                } else if (type == "Effect") {
                    if (this.tableSelectBox.length < 1) {
                        this.$customMessage.error(this.$t('userlang.PleaseOneleast'));
                        return;
                    }
                    this.logoutEffectAjax(1);
                }
            },
            empowerEvent(){
                let params = {}
                params.uids = []
                if(this.tableSelectBox.length < 1){
                    this.$customMessage.error(this.$t('userlang.PleaseOneleast'));
                    return
                }
                let userArr = this.tableSelectBox
                for(let i in userArr){
                    params.uids.push(userArr[i].uid)
                }
                ajax.post(api.USERINVITECODE,params).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                        this.initData()
                    }else{
                        this.$customMessage.error(this.$t('userlang.PleaseOneleast'));
                    }
                })
            },
            initRenderFn(){
                this.parloading = true;
                let params = {
                    functionUid: this.$route.query.funcUid,
                    gmcUid: this.tableGmcuid,
                    language: this.lang,
                    userUid: this.$route.query.userUid,
                    paging: {
                        pageNum: this.currentVal,
                        pageSize: this.pagingSize
                    }
                };


                if (this.pageInfoType == "sort") {
                    params.userSortDtos = this.initRenderFnSearchParamsArr.SortValArr;
                } else if (this.pageInfoType == "tle") {
                    params.columnSearch = this.initRenderFnSearchParamsArr.titleSearchArr;
                } else if (this.pageInfoType == "qf") {
                    params.userSqlDto = this.initRenderFnSearchParamsArr.andvanSearchArr;
                    params.userSqlDto.template = this.parTableTemplateName
                }
                ajax.post(api.SKUS, params).then(res=>{
                    this.parloading = false
                    this.tableSelectBox = []
                    if (res.code == 200) {
                        this.data = res.data;
                        if (this.TitleSearchVal.length > 0) {
                            this.data.tableList.columns = this.TitleSearchVal;
                        }
                        this.pagingTotal = res.data.tableList.paging.totalPageSize;
                        this.substr = this.substr + 1;
                    } else {
                        this.$customMessage.error(res.msg, 5);
                    }
                })
            },

            initData(){
               this.activeKey = ['1','2','3','4']
                let params = {
                    userUid: this.$route.query.userUid,
                    functionUid: this.$route.query.funcUid,
                    language: this.lang,
                    pageNum: 1,
                    pageSize: this.pagingSize
                };
                this.funApi = this.$route.query.funApi
                ajax.get(this.funApi, params).then(res=>{
                    if(res.code == 200){
                        this.parloading = false
                        this.substr = this.substr + 1
                        this.data = res.data
                        this.tableGmcuid = res.data.gmcUid

                        this.pagingTotal = res.data.tableList.paging.totalPageSize;
                        this.pagingSize = res.data.tableList.paging.pageSize;
                    }else {
                        this.data = [];
                        this.$customMessage.error(res.msg);
                    }
                })
            },
//       双击
            getSelectDataTop(val) {
                this.editUserUid = val.uid
                this.editInit()
                this.DrawerVisible = true
                this.form.resetFields();
                this.treeAjaxData()
            },
//       checkbox
            getBoxSelectData(val) {
                this.tableSelectBox = val
            },
//       各种垃圾搜索
            getredSearchVal(val){
                let scParams = [];
                val.forEach((v, i) => {
                    if (v.serVal) {
                        scParams.push({ key: v.uid, value: v.serVal });
                    }
                });
                this.TitleSearchVal = val;
                this.pageInfoType = "tle";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.titleSearchArr = scParams;
                this.initRenderFn();
            },
            getrenderSortVal(paramsArr){
                this.pageInfoType = "sort";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.SortValArr = paramsArr;
                this.initRenderFn();
            },
            getrenderQueryVal(item){
                let jsonArray = item.query;
                jsonArray.gmcUid = this.tableGmcuid;
                let templateName  = item.tml
                if(templateName != undefined && templateName != null){
                  this.parTableTemplateName  = templateName 
                }
                this.pageInfoType = "qf";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.andvanSearchArr = jsonArray;
                this.initRenderFn();
            },
            //    操作固定width 需要重新渲染组件
            GetrederSub(val) {
                this.fixedNum = val;
                this.substr = this.substr + 1;
            },
//       分页
            tableChangePage(current){
                this.currentVal = current;
                this.initRenderFn();
            },

            onShowSizeChange(current, pageSize) {
                this.currentVal = current;
                this.pagingSize = pageSize;
                this.initRenderFn();
            },
//       关闭弹窗
            onCloseDrawer(){
                this.DrawerVisible = false
            },
//       edit Data
            editInit(){
                ajax.get(api.TIMEZONE).then(res => {
                    this.userItmezone = res.data
                });
                let params = {
                    uid: this.editUserUid
                };
                ajax.get(api.USEREDIT, params).then(res=>{
                    this.userEditData = res.data;
                    this.userEditData.organizations = this.sortRecords(this.userEditData.organizations, 'orgCode');
                    this.userEditData.products = this.sortRecords(this.userEditData.products, 'projectCode');
                    this.userEditData.warehouses = this.sortRecords(this.userEditData.warehouses, 'whsCode');
                    this.selectWarehouseRowKeys = [];
//               城市
                    let param = {
                        addressType:0,
                        address:"",
                        lang:1
                    }
                    ajax.post(api.GETUSERADDRESS,param).then(res=>{
                        this.cityOptions = res.data
                        for(let i in this.cityOptions){
                            this.cityOptions[i].isLeaf = false
                        }
                    })
                })
            },
            isEditCityEvent(){
                this.isEditCity = true
            },
            cityChange(val ,selectedOptions){
                this.cityArr = val
            },
            cityLoadData(selectedOptions) {
                const targetOption = selectedOptions[selectedOptions.length - 1];
                targetOption.loading = true;
                let params = {
                    lang:1
                }
                if(selectedOptions.length > 1){
                    params.addressType = 2
                    params.address= selectedOptions[1].ebplCode
                }else{
                    params.addressType = 1
                    params.address= selectedOptions[0].ebplCode
                }
                ajax.post(api.GETUSERADDRESS,params).then(res=>{
                    targetOption.loading = false;
                    let data = res.data
                    for(let i in data){
                        if(selectedOptions.length  ==  1){
                            data[i].isLeaf = false
                        }
                    }
                    targetOption.children = data
                    this.cityOptions = [...this.cityOptions];
                })
            },
            getUserInfo(){
                this.form.validateFields((err,val)=>{
                    if (!err) {
                        this.userGetLoading = true
                        let params = val;
                        params.city = this.cityArr
                        params.uid = this.editUserUid;
                        ajax.put(api.USER, params).then(res => {
                            if (res.code == 200) {
                                this.userGetLoading = false
                                this.initRenderFn()
                                this.$message.success(res.msg);
                            }else{
                                this.$customMessage.error(res.msg);
                                return
                            }
                        })
                    }
                })
            },

//       权限
            onCheck(checkedKeys) {
                this.checkedKeys = checkedKeys;
            },
            onSelect(selectedKeys) {
                this.selectedKeys = selectedKeys;
            },
            treeAjaxData() {
            //  this.selectedRole =[];
               this.findRoleByUser();
                let params = {
                    userUid: this.editUserUid,
                    roleUid: ""
                };
                this.spinning = true;
                ajax.get(api.USERPERMISSION, params).then(res => {
                    this.resetChangesFlag = res.data.resetChangesFlag == '1' ? true : false;
                    this.treeUserData = res.data.permissions;
                    let checkTree = [];
                    for (let i in this.treeUserData) {
                        let aaa = this.treeUserData[i].children;
                        for (let iii in aaa) {
                            let ttt = aaa[iii].children;
                            if(ttt.length == 0 && aaa[iii].checked){
                                checkTree.push(aaa[iii].key);
                            }
                            for (let iii in ttt) {
                                if (ttt[iii].checked) {
                                    checkTree.push(ttt[iii].key);
                                }
                                let hh = ttt[iii].children;
                                for (let it in hh){
                                    if (hh[it].checked) {
                                        checkTree.push(hh[it].key);
                                    }
                                }
                            }
                        }

                    }
                    this.checkedKeys = checkTree;
                    this.spinning = false;
                });
            },
  findRoleByUser(){
 ajax.get(api.USERROLE,{uid: this.editUserUid}).then(res => {

                    this.roleListData = res.data.roleList;
                    let userRoleUids = res.data.userRoleUids;
                    this.selectedRole = [];
                   for (var i = 0; i < this.roleListData.length; i++) {
                            let item = this.roleListData[i];
                          if(userRoleUids.indexOf(item.uid) != -1){
                             this.selectedRole.push(item)
                              this.roleListData.splice(i, 1);
                              i--;
                         }
                     }
                });

  }


            ,
            checkUserTree(){
                this.spinning = true
                let getArr = this.checkedKeys;
                let paramsArr = [];
                for (let index in getArr) {
                    if (isNaN(getArr[index])) {
                        paramsArr.push(getArr[index]);
                    }
                }
                let parasm = {
                    functionList: getArr,
                    userUid: this.editUserUid
                };
                ajax.post(api.USERPERMISSION, parasm).then(res => {
                    if (res.code == 200) {
                        this.$message.success(this.$t('userlang.SaveSuccessfully'));
                        this.spinning = false
                        this.treeAjaxData();
                    }
                });
            },
            copyRoleAuthority(){

                this.roleForm.validateFields((err, val)=>{
                  console.info(val)
                    let params = {
                        roleUid: val.roleid,
                        userUids: [this.editUserUid]
                    };
                    ajax.post(api.USERROLE, params).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.msg);
                            this.treeAjaxData();
                            this.initRenderFn();
                            this.roleForm = this.$form.createForm(this);
                        }
                    })
                })
            }
        }
    };
</script>
<style lang="less">

.role_li {
  display: inline-block;
  background-color: #19A3E6;
  border: 1px solid #19A3E6;
  position: relative;
  padding-right: 12px;
  margin-right: 8px;
  border-radius: 10px;
  margin-top: 5px;
}

 .role_del {
    display: inline-block;
    background-image: url(../../assets/img/close.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 10px;
    height: 10px;
    position: absolute;
    margin-top: 5px;
 }
 
.container {
  // width: 500px;
  // height: 200px;
  // margin:30px 20px;
  background-color: #f1f1f1;
}


  /*抽屉框架样式*/
  .tt {
  }
  .bg {
    background: darkseagreen !important;
  }
  .cc {
    background: #fff;
  }
  .hh {
    background: #e7eef8;
  }
  .ant-checkbox-group {
    .ant-checkbox-group-item {
      display: block;
      margin-top: 4px;
    }
  }
  .drawerCheckClass {
    .drawerCheckHeader {
      border-bottom: 1px solid #e9e9e9;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
.default-proj-reset-button-col {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 32px;
}
.default-proj-reset-button {
  white-space: nowrap;
}
  #userHome {
    .userDetail {
      position: relative;
      height: 100%;
      overflow: hidden;
      background: #fff;
      .userHome-left {
        width: 50%;
        height: 100%;
        float: left;
        padding: 10px;
        position: relative;
        .isShopple {
          position: absolute;
          top: 0;
          right: -32px;
          z-index: 999;
          background: #efefef;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0.8;
        }
        .user-left-con {
          overflow: hidden;
          .user-left-search {
            width: 500px;
            div {
              margin-right: 4px;
            }
          }
        }
      }
      .center-line {
        position: absolute;
        cursor: w-resize;
        left: 50%;
        height: 100%;
        border: 1px solid #efefef;
      }
      .userHome-right {
        float: right;
        width: calc(100% - 50%);
        height: 100%;
        padding: 10px;
        .user-right-con {
          overflow: hidden;
        }
      }
    }
  }
</style>
